"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsigProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const client_core_1 = require("@statsig/client-core");
const StatsigContext_1 = require("./StatsigContext");
function StatsigProvider({ client, children, loadingComponent, }) {
    const [renderVersion, setRenderVersion] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        const onValuesUpdated = () => {
            setRenderVersion((v) => v + 1);
        };
        client_core_1.SDKType._setBindingType('react');
        client.$on('values_updated', onValuesUpdated);
        return () => {
            client
                .flush()
                .catch((err) => client_core_1.Log.error('An error occured during flush', err));
            client.off('values_updated', onValuesUpdated);
        };
    }, [client]);
    const contextValue = (0, react_1.useMemo)(() => ({ renderVersion, client }), [renderVersion, client]);
    return ((0, jsx_runtime_1.jsx)(StatsigContext_1.default.Provider, { value: contextValue, children: loadingComponent == null || _isReady(client)
            ? children
            : loadingComponent }));
}
exports.StatsigProvider = StatsigProvider;
function _isReady(client) {
    if ('isNoop' in client) {
        return true;
    }
    switch (client.loadingStatus) {
        case 'Ready':
            return true;
        default:
            return false;
    }
}
